import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'bidi-right-panel',
  templateUrl: './right-panel.component.html',
  styleUrls: ['./right-panel.component.scss']
})
export class RightPanelComponent {
  @Input() active = false;
  @Output() close = new EventEmitter<void>();

  closePanel (e: Event) {
    e.preventDefault();
    this.close.emit();
  }
}
